export enum ReflectionPanelKindEnum {
  EDITOR = 'editor',
  HISTORY = 'history',
}
